import { useGetCompanyByName } from "@/common/api/queries";
import { companyType } from "@/common/const/types/index.const";
import { Company } from "@/common/types";
import { cn } from "@/common/utils";
import CustomTypography from "@/components/Typography/CustomTypography";
import { Select } from "antd";
import { useState, useEffect } from "react";

export default function SearchCustomerByName({
  value,
  onChange,
  className,
  labelClassName,
  disabled,
}: {
  labelClassName?: string;
  className?: string;
  disabled?: boolean;
  value?: number;
  onChange?: (el: { label: string; value: number }) => void;
}) {
  const [searchQ, setSearchQ] = useState<string>("");
  const [options, setOptions] = useState<{ label: string; value: number }[]>(
    []
  );

  const { data: customerList } = useGetCompanyByName({
    companyType: companyType[0],
    searchQ,
  });

  const onSearch = (value: string) => {
    setSearchQ(value);
  };

  const onSelect = (_: number, option: { label: string; value: number }) => {
    onChange?.(option);
  };

  useEffect(() => {
    if (!customerList) return;
    setOptions(
      customerList.items.map((el: Company) => ({
        value: el.id,
        label: el.companyName,
      }))
    );
  }, [customerList]);

  return (
    <div className="flex flex-col gap-1">
      <CustomTypography as="span" color={"white"} className={labelClassName}>
        Customer{" "}
        <CustomTypography as="span" color={"error"}>
          *
        </CustomTypography>
      </CustomTypography>
      <Select
        className={cn("bg-white min-w-[290px] h-12 rounded-lg", className)}
        placeholder="Customer name"
        value={value}
        onSearch={onSearch}
        showSearch
        disabled={disabled}
        onSelect={onSelect}
        options={options}
        labelInValue
        filterOption={false}
      />
    </div>
  );
}
